import { createAction } from 'redux-actions'

export const SHOW_SOURCE_SETUP = 'SHOW_SOURCE_SETUP'
export const HIDE_SOURCE_SETUP = 'HIDE_SOURCE_SETUP'
export const SHOW_WAREHOUSE_SETUP = 'SHOW_WAREHOUSE_SETUP'
export const HIDE_WAREHOUSE_SETUP = 'HIDE_WAREHOUSE_SETUP'

const createShowSetupAction = type => ({
  workspace,
  ...payload
}) => dispatch => {
  dispatch({ type, payload })
}

export const showSourceSetup = createShowSetupAction(SHOW_SOURCE_SETUP)
export const hideSourceSetup = createAction(HIDE_SOURCE_SETUP)
export const hideWarehouseSetup = createAction(HIDE_WAREHOUSE_SETUP)
